<template>
    <v-dialog :value="value" max-width="620" @input="$emit('input', $event)">
        <v-card class="ui-card">
            <div class="ui-card__header">
                <div>
                    <h3 class="ui-section-title">Baixar documentos (.zip)</h3>
                    <p class="ui-section-description">Pastas por empresa, competência e tipo: <span class="ui-mono">Empresa (CNPJ)/AAAA-MM/NN Tipo/arquivo</span>.</p>
                </div>
            </div>
            <div class="ui-card__body">
                <div class="ui-label">Período</div>
                <ui-pills v-model="mode" :items="[{ value: 'month', text: 'Uma competência' }, { value: 'range', text: 'Intervalo' }]" class="mb-3" />
                <v-row dense>
                    <v-col :cols="mode === 'range' ? 6 : 12">
                        <v-select v-model="from" :items="keyItems" :label="mode === 'range' ? 'De' : 'Competência'" outlined dense hide-details :menu-props="{ offsetY: true }"></v-select>
                    </v-col>
                    <v-col v-if="mode === 'range'" cols="6">
                        <v-select v-model="to" :items="keyItems" label="Até" outlined dense hide-details :menu-props="{ offsetY: true }"></v-select>
                    </v-col>
                </v-row>

                <div class="ui-divider"></div>
                <div class="d-flex align-center">
                    <div class="ui-label mb-0">Tipos de documento</div>
                    <v-spacer></v-spacer>
                    <v-btn x-small text @click="typeIds = typeIds.length === documentTypes.length ? [] : documentTypes.map((type) => type.id)">
                        {{ typeIds.length === documentTypes.length ? "Desmarcar todos" : "Marcar todos" }}
                    </v-btn>
                </div>
                <v-row dense class="mt-1">
                    <v-col v-for="type in documentTypes" :key="type.id" cols="12" sm="6">
                        <v-checkbox v-model="typeIds" :value="type.id" dense hide-details class="mt-0" :label="`${String(type.sort_order).padStart(2, '0')} · ${type.name}`"></v-checkbox>
                    </v-col>
                </v-row>

                <template v-if="companies.length > 1">
                    <div class="ui-divider"></div>
                    <div class="ui-label">Empresas</div>
                    <v-checkbox v-for="company in companies" :key="company.id" v-model="companyIds" :value="company.id" dense hide-details class="mt-0" :label="company.name"></v-checkbox>
                </template>
            </div>
            <div class="ui-card__footer">
                <span v-if="progress" class="ui-small ui-muted mr-auto">{{ progress }}</span>
                <v-btn outlined :disabled="loading" @click="$emit('input', false)">Cancelar</v-btn>
                <v-btn color="primary" depressed :loading="loading" :disabled="!canDownload" @click="download">Gerar .zip</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { competenceLabel, notifyError } from "@/components/rma/rma.util";

// Download em lote dos documentos do caso (D4).
export default {
    name: "RmaArchiveDialog",

    props: {
        value: { type: Boolean, default: false },
        clientId: { type: Number, required: true },
        competences: { type: Array, default: () => [] },
        companies: { type: Array, default: () => [] },
        documentTypes: { type: Array, default: () => [] },
        // Competencia aberta na tela (vira o padrao do periodo).
        currentKey: { type: String, default: null },
    },

    data: () => ({ mode: "month", from: null, to: null, typeIds: [], companyIds: [], loading: false, progress: "" }),

    computed: {
        keyItems() {
            return this.competences.map((item) => ({ value: item.key, text: competenceLabel(item.key) }));
        },
        canDownload() {
            return !!this.from && (this.mode === "month" || !!this.to) && this.typeIds.length > 0;
        },
    },

    watch: {
        value(open) {
            if (!open) return;
            const keys = this.competences.map((item) => item.key);
            const initial = this.currentKey && keys.includes(this.currentKey) ? this.currentKey : keys[0] || null;
            this.from = initial;
            this.to = initial;
            this.typeIds = this.documentTypes.filter((type) => type.selected !== false).map((type) => type.id);
            this.companyIds = this.companies.map((company) => company.id);
            this.progress = "";
        },
    },

    methods: {
        async download() {
            const [from, to] = this.mode === "month" ? [this.from, this.from] : [this.from, this.to].sort();
            this.loading = true;
            this.progress = "Gerando o arquivo...";
            try {
                const params = { from, to, type_ids: this.typeIds.join(",") };
                if (this.companies.length > 1 && this.companyIds.length !== this.companies.length) params.company_ids = this.companyIds.join(",");
                const result = await axios.get(`/api/admin/rma/clients/${this.clientId}/archive`, {
                    params,
                    responseType: "blob",
                    onDownloadProgress: (event) => {
                        if (event.loaded) this.progress = `Baixando ${(event.loaded / (1024 * 1024)).toFixed(1).replace(".", ",")} MB...`;
                    },
                });
                const disposition = result.headers["content-disposition"] || "";
                const match = disposition.match(/filename="([^"]+)"/);
                const url = window.URL.createObjectURL(result.data);
                const link = document.createElement("a");
                link.href = url;
                link.download = match ? match[1] : `RMA_${from}.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.$emit("input", false);
            } catch (error) {
                // Erro de API chega como Blob quando responseType = blob.
                if (error.response && error.response.data instanceof Blob) {
                    try {
                        error.response.data = JSON.parse(await error.response.data.text());
                    } catch (parseError) {
                        // mantem o erro original
                    }
                }
                notifyError(this, error);
            } finally {
                this.loading = false;
                this.progress = "";
            }
        },
    },
};
</script>
